export const DAYS_WINDOW = 60;
// 60 non-Sunday days span at most 70 calendar days.
export const DAYS_WINDOW_CALENDAR_SPAN = Math.ceil((DAYS_WINDOW * 7) / 6);

export const NFB_SLOT_DURATION_MIN = 45;

export const PSY_HOURLY_SLOTS = [
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
    "18:00",
    "19:00",
];

export const NFB_WEEKDAY_SLOTS = [
    "10:00",
    "10:45",
    "11:30",
    "12:15",
    "14:00",
    "14:45",
    "15:30",
    "16:15",
    "17:30",
    "18:15",
    "19:00",
];

// Must match the backend canonical NFB Saturday times (availabilities-finder nfbAllowedTimesSaturdayNew).
export const NFB_SATURDAY_SLOTS = [
    "09:15",
    "10:00",
    "10:45",
    "11:30",
    "12:15",
    "14:00",
    "14:45",
    "15:30",
    "16:15",
    "17:15",
    "18:00",
];

export const UNIFIED_15MIN_SLOTS = [
    "09:00", "09:15", "09:30", "09:45",
    "10:00", "10:15", "10:30", "10:45",
    "11:00", "11:15", "11:30", "11:45",
    "12:00", "12:15", "12:30", "12:45",
    "13:00", "13:15", "13:30", "13:45",
    "14:00", "14:15", "14:30", "14:45",
    "15:00", "15:15", "15:30", "15:45",
    "16:00", "16:15", "16:30", "16:45",
    "17:00", "17:15", "17:30", "17:45",
    "18:00", "18:15", "18:30", "18:45",
    "19:00", "19:15", "19:30", "19:45",
];

export const WEEK_DAY_SHORT_LABELS: Record<number, string> = {
    1: "Seg",
    2: "Ter",
    3: "Qua",
    4: "Qui",
    5: "Sex",
    6: "Sáb",
};

export const WEEK_DAY_FULL_LABELS: Record<number, string> = {
    1: "Segunda-Feira",
    2: "Terça-Feira",
    3: "Quarta-Feira",
    4: "Quinta-Feira",
    5: "Sexta-Feira",
    6: "Sábado",
};

export const SATURDAY_WEEKDAY = 6;

// Colours shared across the grid, the cell and the popover (cross-folder, so they live here
// rather than in grid/gridUtils.ts to avoid list/ or shared/ depending on grid/).
export const SATURDAY_HIGHLIGHT_COLOR = "#fff3e0";
export const PSY_BOOKING_PURPLE = "#7b1fa2";
export const WARNING_RED = "#c62828";
